import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import { useRedis } from '@/hooks/useRedis'
import { useAppSelector } from '@/redux/hooks'
import { useEffect, useState } from 'react'
import {
  errorMessages,
  menuInfo,
  MenuInfoData,
  successMessages,
} from '../menuInfoMgmtItem'
import { fromRatio } from 'tinycolor2'
import commonUtils from '@/utils/commonUtils'

type SetMenuInnfoProps = {
  path?: string
  label?: string
  code: string
  menuList?: MenuInfoData[]
  getMenuInfoList: () => void
}

const SetMenuInfoMgmt: React.FC<SetMenuInnfoProps> = ({
  path,
  label,
  code,
  menuList,
  getMenuInfoList,
}) => {
  const axios = useAxios()
  const { showAlert, showConfirm } = useDialog()
  const { getComCodes, getComCodeValue } = useRedis()
  const { isAuthenticated, user } = useAppSelector((state) => state.auth)
  const [isOpen, setIsOpen] = useState(true)
  const [formData, setFormData] = useState({
    cmpnyCd: '001',
    menuPath: path, // 현재 (변경될 수 있음)
    menuPathSn: 0,
    code: '',
    regId: user?.cstId,
    regDate: '',
    updId: user?.cstId,
    updDate: '',
    useYn: 'Y',
    delYn: 'N',
  })

  // useEffect(() => {
  //   getMenuInfoList() // path가 변경될 때마다 메뉴 정보를 새로 가져옴
  // }, [])

  // const getMenuInfoList = async () => {
  //   try {
  //     const response = await axios.get(`/menu/getMenuInfoList`)
  //     const menuList: MenuInfoData[] = response.data.data.menuList
  //     // 현재 path에 해당하는 메뉴 정보를 찾기
  //     const found = menuList.find((item) => item.code === code)

  //     if (found) {
  //       setFormData({
  //         cmpnyCd: found.cmpnyCd,
  //         menuPath: found.menuPath, // 현재 선택된 path의 menuPath
  //         menuPathSn: found.menuPathSn, // 현재 선택된 path의 menuPathSn
  //         code: found.code,
  //         regId: user?.cstId,
  //         regDate: found.regDate,
  //         updId: user?.cstId,
  //         updDate: found.updDate,
  //         useYn: found.useYn,
  //         delYn: found.delYn,
  //       })
  //     }
  //   } catch (err) {
  //     //TODO 에러처리필요
  //     showAlert({
  //       type: 'error',
  //       title: '리스트 조회 중 오류 발생',
  //     })
  //     console.error('Error fetching List:', err)
  //   }
  // }

  useEffect(() => {
    console.log('formData이 변경됨', formData)
  }, [formData])

  useEffect(() => {
    // 전달받은 menuList에서 code와 일치하는 항목을 찾음
    const found = menuList?.find((item: any) => item.code === code)

    if (found) {
      setFormData({
        cmpnyCd: found.cmpnyCd,
        menuPath: found.menuPath,
        menuPathSn: found.menuPathSn,
        code: found.code,
        regId: found.regId,
        regDate: found.regDate,
        updId: found.updId,
        updDate: found.updDate,
        useYn: found.useYn,
        delYn: found.delYn,
      })
    }
  }, [menuList, code]) // menuList나 code가 변경될 때마다 실행

  //메뉴정보등록(isNewMenu에 따라서 url 변경)
  const setMenuInfo = async () => {
    try {
      // menuPathSn이 존재하면 업데이트, 없으면 삽입 처리
      // const url = formData.menuPathSn
      //   ? `/menu/updateMenuInfo`
      //   : `/menu/setMenuInfo`

      const response = await axios.post(`/menu/setMenuInfo`, formData)

      if (response.status === 200 && !response.data.common.resultCode) {
        showAlert({
          type: 'success',
          title: successMessages.insert,
        })
        getMenuInfoList() // 저장 후 최신화
      }
    } catch (err) {
      showAlert({
        type: 'error',
        title: errorMessages.insert,
      })
    }
  }

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  return (
    <form style={{ gap: '0px' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: isOpen ? '5px' : '0px',
          cursor: 'pointer',
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <label htmlFor="menuPath">
          <span style={{ color: '#d09d30', fontWeight: 'bold' }}>{label}</span>
          {menuInfo.title}
        </label>
        {formData.updDate && (
          <div
            style={{
              fontSize: '14px',
              color: '#d09d30',
              fontWeight: 'bold',
              display: 'flex',
              justifyItems: 'center',
              alignItems: 'center',
            }}
          >
            <span>{`${menuInfo.updDate}: ${commonUtils.formatDate(formData.updDate, true)}`}</span>
          </div>
        )}
      </div>
      {isOpen && (
        <div className="form-footer" style={{ margin: '0px' }}>
          <div className="select-group">
            <div className="select-item">
              <label htmlFor="delYn">메뉴경로</label>
              <input
                key={formData.menuPathSn}
                type="text"
                id="menuPath"
                name="menuPath"
                value={formData.menuPath}
                maxLength={255}
                //readOnly={true}
                disabled={true}
                style={{ width: '120px' }}
                onChange={handleChange}
              />
            </div>
            <div className="select-item">
              <label htmlFor="useYn">사용여부</label>
              <select
                id="useYn"
                name="useYn"
                value={formData.useYn}
                onChange={handleChange}
              >
                {getComCodes('USE_YN').map((item) => (
                  <option key={'useYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </select>
            </div>
            <div className="select-item">
              <label htmlFor="delYn">삭제여부</label>
              <select
                id="delYn"
                name="delYn"
                value={formData.delYn}
                onChange={handleChange}
              >
                {getComCodes('DEL_YN').map((item) => (
                  <option key={'delYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <button type="button" className="submit-btn" onClick={setMenuInfo}>
            저장
          </button>
        </div>
      )}
    </form>
  )
}

export default SetMenuInfoMgmt
